<template>
    <p-form @submit="onSubmit">
        <div class="container-fluid content-wrapper" v-if="account">
            <b-row class="content-heading">
                <b-col>
                    <div>{{ isNew ? 'Add' : 'Edit' }} AR Account</div>
                    <span v-if="account.agencyName != null || ''">
                    <h2> {{account.agencyName + '('+ account.accountCode +')' }}</h2>
                    </span>
                </b-col>
                <b-col cols="auto" class="ms-auto">
                    <p-button type="submit" variant="primary" :is-busy="isBusy">Save</p-button>
                </b-col>
            </b-row>
            <b-tabs justified class="non-printable">
                <b-tab title="Profile">
                    <Profile-Tab :account="account"
                                 :is-new="isNew"
                                 @load-data="loadData"
                                 @date-picker-initialized="e => {dataLoaded()}" />
                </b-tab>
                <b-tab title="Customers" v-if="!isNew">
                    <CustomersTab @load-data="loadData" :account="account" ref="customersTab" />
                </b-tab>
                <b-tab title="Account Activity">
                    <AccountActivityTab :account="account" ref="AccountActivityTab" />
                </b-tab>
                <p-feature-flag ref="ArAccountDCCsFlag" name="AR Account DCCs">
                    <b-tab title="DCC's">
                        <DccTab :dccs="dccs" :selectedDcc="dccs" ref="dccTab" />
                    </b-tab>
                </p-feature-flag>
                <p-feature-flag ref="nonMerchFlag" name="Non Merch">
                    <b-tab title="Non-Merch">
                        <NonMerchTab 
                            :account="account"
                            :included-special-item-ids="includedSpecialItemIds"
                            ref="nonMerchTab" />
                    </b-tab>
                </p-feature-flag>
            </b-tabs>
            <b-row class="mt-3">
                <b-col class="text-center mb-3">
                    <p-button variant="primary" type="submit" :is-busy="isBusy">
                        Save
                    </p-button>
                </b-col>
            </b-row>
        </div>
    </p-form>
</template>
<script>
import axios from 'axios';
import editPage from '@/components/mixins/EditPage';
import NavigationGuard from '@/components/mixins/NavigationGuard.js';
import ProfileTab from './ProfileTab.vue';
import CustomersTab from './CustomersTab.vue';
import DccTab from './DccTab.vue'
import AccountActivityTab from './AccountActivityTab.vue';
import NonMerchTab from './NonMerchTab.vue';

export default {
    mixins: [NavigationGuard, editPage],
    components: { ProfileTab, CustomersTab, AccountActivityTab, DccTab, NonMerchTab },
    props: {
        id: String
    },
    data() {
        return {
            account: null,
            isBusy: false,
            dccs:[],
            includedSpecialItemIds: []
        };
    },
    methods: {
        loadData() {
            (this.isNew ?
                axios.get('Accountreceivable/new') :
                axios.get('Accountreceivable', {params: {id: this.id}})
             ).then(response => {

                const account = response.data;

                account.type = null;
                if (this.isNew) {
                    account.accountType = null;
                } else {
                    if (account.isDebit) {
                        account.type = 2;
                    } else{
                        account.type = 1;
                    }
                }
                this.account = account;
                this.dataLoaded();
            });

            if (!this.isNew) {
                axios.get('accountreceivable/Dccs', {params: {id: this.id}}).then(response => {
                    this.dccs = this.setAllowsDiscountsFlagForDccs(response.data);
                    this.dataLoaded();
                });

                axios.get('accountreceivable/nonmerch', {params: {id: this.id}}).then(response => {
                    this.includedSpecialItemIds = response.data;
                    this.dataLoaded();
                });
            }
        },
        setAllowsDiscountsFlagForDccs(arr){
            arr.map((obj)=>{
                obj.dccClasses.map((obj)=>{
                       obj.dccCategories.some(ele => ele['allowsDiscounts'] === false)?obj.allowsDiscounts = false:obj.allowsDiscounts = true;
                });
                obj.dccClasses.some(ele => ele['allowsDiscounts'] === false)?obj.allowsDiscounts = false:obj.allowsDiscounts = true;
            })
            return arr;
        },
        filterDccs(arr){
            const fiterdArr = [];
            arr.map((obj)=>{
                obj.dccClasses.map((obj)=>{
                    obj.dccCategories.map((obj)=>{
                        if(obj.isActive === true || (obj.percentDiscount != null))fiterdArr.push(obj);
                    })
                })
            })
            return fiterdArr;
        },
        onSubmit() {
            this.isBusy = true;
            const account = {...this.account};
            delete account.type;
            account.dccs = this.filterDccs(this.dccs);
            account.includedSpecialItemIds = [...this.includedSpecialItemIds];
            axios.post('Accountreceivable', account).then(response => {
                if (this.isNew) {
                    // Don't mutate this.account on the new path — the deep
                    // NavigationGuard.$watcher would flip formIsDirty back to
                    // true between dataSaved() and the router guard, producing
                    // a stray "leave without saving?" prompt.
                    this.dataSaved();
                    this.$router.push('/accountreceivable/' + response.data);
                } else {
                    this.account.accountId = response.data;
                    this.dataSaved();
                }
                this.$appSuccess(
                        `Account '${this.account.accountCode}' saved successfully.`
                    )
            }).finally(() => {
                this.isBusy = false;
            });
        }
    },
    computed: {
        isNew() {
            return this.id === 'new';
        }
    },
    watch: {
        account: NavigationGuard.$watcher,
        dccs: NavigationGuard.$watcher,
        includedSpecialItemIds: NavigationGuard.$watcher,
        $route: function(to, from) {
            if (to !== from) {
                this.loadData();
            }
        }
    },
    mounted() {
        this.loadData();
    }
};
</script>
<style scoped lang="scss">
@media print {
    /* this is to handle hiding <b-tabs> */
    :deep(.non-printable ul), :deep(.non-printable ul *) {
        visibility: hidden;
    }
}
</style>
